import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import {
  Button,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Radio,
} from "@mui/material";

import Select from "react-select";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Loader from "../../components/Loader";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import bigDecimal from "js-big-decimal";

import useCreateAudit from "../../mutation/audit/createAudit";
import useProperty from "../../queries/property/getProperties";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  amount: yup
    .number()
    .typeError("Amount must be a number")
    .required("Amount is required")
    .min(0, "Amount needs to be 0 or positive"),
  reservationId: yup.string().required("Reservation Number is required"),
  property: yup.object().required("A Property must be selected."),
  schedule: yup.string().required("A Schedule must be selected."),
});

const NewCreditNote = (props) => {
  const history = useHistory();

  const [auditResponse, setAuditData] = useCreateAudit();

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      schedule: "mid",
    },
  });

  const [propertyResponse, resetProperty] = useProperty();

  const [propertyOptions, setPropertyOptions] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState();

  useEffect(() => {
    if (propertyResponse.data) {
      let data = propertyResponse.data;
      let propertyOptions = [];
      for (var i = 0; i < data.length; i++) {
        let property = data[i];
        propertyOptions.push({
          label: property.name,
          value: property.id,
        });
      }

      setPropertyOptions(propertyOptions);
    }
  }, [propertyResponse]);

  const propertyChange = (value) => {
    if (value != null) {
      setValue("property", { label: value.label, value: value.value });

      setSelectedProperty(value.value);
    }
  };

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const goBack = () => {
    window.location.href = "/dashboard/creditnote";
  };

  const onSubmit = (values) => {
    if (values.amount && values.schedule == "mid") {
      let amountSplit = bigDecimal.round(values.amount / 2, 2);
      values.amount1 = amountSplit;
      values.amount2 = amountSplit;
    } else {
      values.amount1 = values.amount;
    }

    delete values.amount;

    if (values.property) {
      values.property = values.property.value;
    }

    Swal.fire({
      title: "Create Updates",
      html: `<h4>Please provide a description before submitting your changes</h4>
            <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: values,
          type: "credit-notes",
          action: "createManual",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAuditData(result.value);
      }
    });
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Credit Note Audit created",
        });
        history.push("/dashboard/creditnote");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          if (message == "Invalid Reservation Id") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "The Reservation Number provided is not valid",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  var countDecimals = function (value) {
    if (Math.floor(value) === value) return 0;
    if (value.toString().split(".").length > 1) {
      return value.toString().split(".")[1].length || 0;
    } else {
      return 0;
    }
  };

  const onAmountChanged = (event, field) => {
    let value = event.target.value;
    if (countDecimals(value) > 2) {
      setValue(field, Number(value).toFixed(2));
    }
  };

  const renderContent = () => {
    return (
      <FormPageShell>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormPageCard>
            <FormPageHeader
              title="New Credit Note"
              onBack={goBack}
              subtitle="Please fill in the required fields."
            />
            <TextField
              name="amount"
              margin="normal"
              fullWidth
              label="Total Amount*"
              variant="outlined"
              inputRef={register}
              type="number"
              error={errors.amount != null}
              onChange={(event) => {
                onAmountChanged(event, "amount");
              }}
              helperText={
                errors.amount != null ? errors.amount.message : null
              }
              disabled={auditResponse.loading}
            />
            <TextField
              name="reservationId"
              margin="normal"
              fullWidth
              label="Reservation Number*"
              variant="outlined"
              inputRef={register}
              error={errors.reservationId != null}
              helperText={
                errors.reservationId != null
                  ? errors.reservationId.message
                  : null
              }
              disabled={auditResponse.loading}
            />
            <div>
              <Typography sx={{ fontSize: 16, fontWeight: "bold", mt: 1 }}>
                Property of Reservation
              </Typography>
              <div>
                <Controller
                  name="property"
                  control={control}
                  render={({ ...props }) => {
                    return (
                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: errors.type
                              ? "red"
                              : provided.borderColor,
                          }),
                        }}
                        options={propertyOptions}
                        onChange={propertyChange}
                        disabled={auditResponse.loading}
                      />
                    );
                  }}
                />
                {errors.property && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mx: 1.75, mt: 0.375, display: "block" }}
                  >
                    {errors.property.message}
                  </Typography>
                )}
              </div>
            </div>
            <FormControl component="fieldset">
              <Typography sx={{ fontSize: 16, fontWeight: "bold", mt: 1 }}>
                Schedule
              </Typography>
              <Controller
                rules={{ required: true }}
                control={control}
                name="schedule"
                as={
                  <RadioGroup defaultValue={"mid"}>
                    <FormControlLabel
                      value="mid"
                      control={<Radio disabled={auditResponse.loading} />}
                      label="Mid- & 4 weeks before end-lease (50-50 amount)"
                    />
                    <FormControlLabel
                      value="end"
                      control={<Radio disabled={auditResponse.loading} />}
                      label="4 weeks before end-lease"
                    />
                  </RadioGroup>
                }
              />
            </FormControl>
            {errors.schedule && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mx: 1.75, mt: 0.375, display: "block" }}
              >
                {errors.schedule.message}
              </Typography>
            )}
          </FormPageCard>
          <FormPageCard sx={{ mt: 2 }}>
            <FormActions>
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="primary"
                disabled={auditResponse.loading}
              >
                Submit
              </Button>
            </FormActions>
          </FormPageCard>
        </form>
      </FormPageShell>
    );
  };

  return (
    <div>
      {propertyResponse.loading && (
        <FormPageCard>
          <Loader />
        </FormPageCard>
      )}
      {!propertyResponse.loading && renderContent()}
    </div>
  );
};

export default NewCreditNote;
